export default "/assets/images/rookie-parent4.9feca135367d447d.png";